import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { YarnQcSearch } from '../../models/yarn/yarn-qc-search';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { SupportingDocument, YarnQC } from '../../models/yarn/yarn-qc';

@Injectable({
  providedIn: 'root',
})
export class YarnQcProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.inventoryApi + '/api/v1/yarn-qc';

  getYarnsQC(yarnQcSearch: YarnQcSearch): Observable<ApiResponse<YarnQC[]>> {
    const params = new HttpParams();
    params.set('matchAny', true);
    return this.httpClient.post<ApiResponse<YarnQC[]>>(`${this.baseUrl}/search`, yarnQcSearch, { params });
  }

  getYarnQC(id: string): Observable<ApiResponse<YarnQC>> {
    return this.httpClient.get<ApiResponse<YarnQC>>(`${this.baseUrl}/${id}`);
  }

  createYarnQC(data: YarnQC): Observable<ApiResponse<YarnQC>> {
    return this.httpClient.post<ApiResponse<YarnQC>>(`${this.baseUrl}`, data);
  }

  updateYarnQC(data: YarnQC) {
    return this.httpClient.put(`${this.baseUrl}/${data.id}`, data);
  }

  deleteYarnQC(idYarnQC: string) {
    return this.httpClient.delete(`${this.baseUrl}/${idYarnQC}`);
  }

  uploadYarnQCFiles(
    idYarnQC: string,
    idCodeKey: string | null,
    files: FileList,
    typeUpload: number,
  ): Observable<ApiResponse<SupportingDocument[]>> {
    // Validar que haya archivos
    if (!files || files.length === 0) {
      return throwError(() => new Error('No files provided'));
    }

    // Configurar parámetros base
    let params = new HttpParams().set('yarnQualityControlId', idYarnQC).set('yarnQualityUploadType', typeUpload.toString());

    // Solo agregar itemCodeKeyWithResultsId si es typeUpload 1 y idCodeKey no es null
    if (typeUpload === 1 && idCodeKey) {
      params = params.set('itemCodeKeyWithResultsId', idCodeKey);
    }

    // Crear FormData y agregar archivos
    const formData = new FormData();

    for (const file of Array.from(files)) {
      formData.append('files', file, file.name);
    }

    return this.httpClient
      .post<ApiResponse<SupportingDocument[]>>(`${this.baseUrl}/upload-files`, formData, {
        params,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Upload error:', error);
          return throwError(() => new Error(`Upload failed: ${error.message}`));
        }),
      );
  }

  deleteFiles(
    idYarnQC: string,
    idCodeKey: string | null,
    doc: SupportingDocument[],
    typeUpload: number,
  ): Observable<ApiResponse<SupportingDocument[]>> {
    let params = new HttpParams().set('yarnQualityControlId', idYarnQC).set('yarnQualityUploadType', typeUpload.toString());
    if (idCodeKey) {
      params = params.set('itemCodeKeyWithResultsId', idCodeKey);
    }

    return this.httpClient.post<ApiResponse<SupportingDocument[]>>(`${this.baseUrl}/delete-files`, doc, {
      params,
      reportProgress: true,
    });
  }
}
